import axios from 'axios'
import { request } from './request.js'


//获取阿里云OSS相关配置
export function getAliyunOssinfo (method) {
  return request({
    url: '/common/oss-upload-init',
    method,
  })
}

//通过获取相关配置，开始上传图片
export function uploadFile (images) {
  return new Promise((resolve, reject) => {  
    getAliyunOssinfo('GET').then((res) => {
      console.log("123123123",res);
      const host = 'https://newapi.guansj.com/api/common/upload'
      const formData = new FormData()
    
      formData.append('file', images)
      axios.post(host, formData).then((res) => {
      
        resolve(res.data)
      }).catch(err => {

        reject(err)
      })
    }).catch(err => {})
  })
}
